import React, { useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, Stack } from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import PropTypes from "prop-types";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ActionsMenuGrid from "./ActionsMenuGrid";
import ComponentSelectDialog from "./ComponentSelectDialog";
import ComponentSelectMarksDialog from "./ComponentSelectMarksDialog";
import MarksEntryDialog from "./MarksEntryDialog";
import axios from "axios";
export default function CourseAllotmentGrid({ courses }) {
  const user = JSON.parse(sessionStorage.getItem("user"));
  const clientId = user?.client_id;
  const collegeId = user?.college_id;
  const [uploading, setUploading] = React.useState(false);
  const [uploadedCourses, setUploadedCourses] = React.useState({});
  const [componentDialogOpen, setComponentDialogOpen] = React.useState(false);
  const [selectedCourseRow, setSelectedCourseRow] = React.useState(null);
  const [componentMarksDialogOpen, setComponentMarksDialogOpen] = React.useState(false);
  const [selectedCourseMarksRow, setSelectedCourseMarksRow] = React.useState(null);
  const [marksDialogOpen, setMarksDialogOpen] = React.useState(false);
  const [selectedComponent, setSelectedComponent] = React.useState(null);

  const [componentDialogAllOpen, setComponentDialogAllOpen] = React.useState(false);
  const [downloadProgress, setDownloadProgress] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const program = courses[0]?.program_name || "";
  const branch = courses[0]?.branch_name || "";
  const admittedbatch = courses[0]?.admittedbatch || "";
  const year_number = courses[0]?.year_number || "";
  const semester_number = courses[0]?.semester_number || "";
  const columns = [
    { field: "sno", headerName: "SNo", width: 70 },
    { field: "course_code", headerName: "Course Code", width: 150 },
    { field: "course_name", headerName: "Course Name", width: 300 },
    { field: "course_type", headerName: "Type", width: 60 },
    { field: "course_category", headerName: "Category", width: 100 },
    { field: "allotted_count", headerName: "Students", width: 100 },

    {
      field: "actions",
      headerName: "Actions",
      width: 360,
      sortable: false,
      renderCell: (params) => {
        const isUploaded = uploadedCourses[params.row.exam_course_id];

        return (
          <ActionsMenuGrid
            row={params.row}
            isUploaded={isUploaded}
            onDownloadList={openComponentDialog}
            onUploadCSV={handleUploadCSV}
            onDownloadMarks={openComponentMarksDialog}
          />
        );
      },
    },
  ];

  const openComponentDialog = (courseRow) => {
    setSelectedCourseRow(courseRow);
    setComponentDialogOpen(true);
  };
  const openComponentMarksDialog = (courseRow) => {
    setSelectedCourseMarksRow(courseRow);
    setComponentMarksDialogOpen(true);
  };
  const closeMarksDialog = () => {
    setMarksDialogOpen(false);
    setComponentDialogOpen(true);
  };
  const sortedCourses = [...courses].sort((a, b) => {
    const baseA = a.course_code.replace(/P$/, "");
    const baseB = b.course_code.replace(/P$/, "");

    if (baseA !== baseB) return baseA.localeCompare(baseB);

    if (a.course_type === "T" && b.course_type === "P") return -1;
    if (a.course_type === "P" && b.course_type === "T") return 1;

    return 0;
  });
  const rows = sortedCourses.map((c, index) => ({
    id: c.exam_course_id, // MUST BE STABLE
    sno: index + 1,
    ...c,
  }));

  React.useEffect(() => {
    if (!courses?.length) return;

    const loadUploadedCourses = async () => {
      try {
        const res = await axios.post(
          `${API_BASE_URL}/api/internal-marks/${clientId}/${collegeId}/existing`,
          {
            courses: courses.map((c) => ({
              exam_course_id: Number(c.exam_course_id),
              course_code: c.course_code,
              year_number: Number(c.year_number),
              semester_number: Number(c.semester_number),
              student_rollnos: c.student_rollnos || [],
            })),
          }
        );

        const map = {};
        res.data.data.forEach((row) => {
          map[row.exam_course_id] = row.hasInternalMarks;
        });

        setUploadedCourses(map);
      } catch (e) {
        console.error(e);
      }
    };

    loadUploadedCourses();
  }, [courses, clientId, collegeId]);

  const handleDownloadStudentList = (courseRow, component) => {
    if (!courseRow?.student_rollnos?.length) {
      alert("No students allotted");
      return;
    }

    let csvContent =
      "sno,course_code,course_name,component_id,component_name,student_rollno,marks\n";

    csvContent += courseRow.student_rollnos
      .map((rollno, index) => {
        const sno = index + 1; // 👈 serial number
        return `${sno},${courseRow.course_code},${courseRow.course_name},${component.component_id},${component.component_name},${rollno},`;
      })
      .join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute(
      "download",
      `${courseRow.course_code}_${courseRow.course_name}_${component.component_name}_Rollnos_list.csv`
    );

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handleDownloadStudentListPDF = async (courseRow, component) => {
    if (!courseRow?.student_rollnos?.length) {
      alert("No students allotted");
      return;
    }

    try {
      const payload = {
        ...courseRow,
        component, // 👈 added
      };
      const response = await axios.post(
        `${API_BASE_URL}/api/internal-marks/student-list-pdf/${clientId}/${collegeId}`,
        payload,
        {
          responseType: "blob",
        }
      );

      const fileName = `StudentList_${courseRow.course_code}.pdf`;
      const blobUrl = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );

      window.open(blobUrl, "_blank");

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("PDF download error", err);
    }
  };

  const handleDownloadMarksList = async (courseRow) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/internal-marks/${clientId}/${collegeId}/download`,
        {
          courses: [
            {
              exam_course_id: Number(courseRow.exam_course_id),
              course_code: courseRow.course_code,
              year_number: Number(courseRow.year_number),
              semester_number: Number(courseRow.semester_number),
              student_rollnos: courseRow.student_rollnos || [],
            },
          ],
        },
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));

      const link = document.createElement("a");
      link.href = url;
      link.download = `${courseRow.course_code}_internal_marks.csv`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error(err);
      alert("Internal marks not available ❌");
    }
  };

  const handleUploadCSV = async (event, courseRow) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    formData.append("exam_course_id", courseRow.exam_course_id);
    formData.append("course_code", courseRow.course_code);
    formData.append("college_id", collegeId);
    formData.append("year_number", courseRow.year_number);
    formData.append("semester_number", courseRow.semester_number);
    formData.append("created_by", user.user_email);
    try {
      await axios.post(`${API_BASE_URL}/api/internal-marks/${clientId}/${collegeId}/csv`, formData);
      setUploadedCourses((prev) => ({
        ...prev,
        [courseRow.exam_course_id]: true,
      }));
      alert(`Marks uploaded for ${courseRow.course_code} ✅`);
    } catch (err) {
      console.error("Upload error:", err.response?.data || err.message);
      alert(err.response?.data?.message || "Upload failed ❌");
    }
  };

  const handleCSV = () => {
    const headerInfo = `Program: ${program}, Branch: ${branch}, Admitted Batch: ${admittedbatch} , Year Number: ${year_number}, Semester Number: ${semester_number} \n\n`;

    const headers = "S.No,Course Code,Course Name,Course Type,Course Category,Allotted Students";

    const rowsCSV = courses
      .map(
        (c, i) =>
          `${i + 1},${c.course_code},${c.course_name},${c.course_type},${c.course_category},${
            c.allotted_count
          }`
      )
      .join("\n");

    const csvContent = headerInfo + headers + "\n" + rowsCSV;

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "course_allotment.csv");
    link.click();
  };

  // -------------------------------------------------
  // PDF EXPORT
  // -------------------------------------------------
  const handlePDF = () => {
    const doc = new jsPDF();

    doc.text("Allotted Courses Report", 14, 10);
    doc.setFontSize(11);
    doc.text(`Program: ${program}`, 14, 18);
    doc.text(`Branch: ${branch}`, 14, 24);
    doc.text(`Admitted Batch: ${admittedbatch}`, 14, 30);
    doc.text(`Year Number: ${year_number}`, 14, 40);
    doc.text(`Semester Number: ${semester_number}`, 14, 50);

    autoTable(doc, {
      startY: 36,
      head: [
        [
          "S.No",
          "Course Code",
          "Course Name",
          "Course Type",
          "Course Category",
          "Allotted Students",
        ],
      ],
      body: courses.map((c, i) => [
        i + 1,
        c.course_code,
        c.course_name,
        c.course_type,
        c.course_category,
        c.allotted_count,
      ]),
    });

    doc.save("course_allotment.pdf");
  };

  // -------------------------------------------------
  // PRINT
  // -------------------------------------------------
  const handlePrint = () => {
    const printContent = `
    <html>
      <head>
        <title>Course Allotment</title>
        <style>
          table { width: 100%; border-collapse: collapse; font-size: 14px; }
          th, td { border: 1px solid #000; padding: 8px; text-align: left; }
          th { background: #eee; }
        </style>
      </head>
      <body>
        <h2>Allotted Courses Report</h2>

        <p><strong>Program:</strong> ${program}</p>
        <p><strong>Branch:</strong> ${branch}</p>
        <p><strong>Admitted Batch:</strong> ${admittedbatch}</p>
         <p><strong>Year Number:</strong> ${year_number}</p>
        <p><strong>Semester Number:</strong> ${semester_number}</p>
        <br/>

        <table>
          <tr>
            <th>S.No</th>
            <th>Course Code</th>
            <th>Course Name</th>
            <th>Course Type</th>
            <th>Course Category</th>
            <th>Allotted Students</th>
          </tr>
          ${courses
            .map(
              (c, i) => `
            <tr>
              <td>${i + 1}</td>
              <td>${c.course_code}</td>
              <td>${c.course_name}</td>
              <td>${c.course_type}</td>
              <td>${c.course_category}</td>
              <td>${c.allotted_count}</td>
            </tr>`
            )
            .join("")}
        </table>
      </body>
    </html>
  `;

    const printWindow = window.open("", "", "width=900,height=600");
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  };
  const handleDownloadAllInternalMarks = async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/internal-marks/${clientId}/${collegeId}/download-all`,
        {
          courses: courses.map((c) => ({
            exam_course_id: Number(c.exam_course_id),
            course_code: c.course_code,
            year_number: Number(c.year_number),
            semester_number: Number(c.semester_number),
            student_rollnos: c.student_rollnos || [],
          })),
        },
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }));

      const link = document.createElement("a");
      link.href = url;
      link.download = "all_internal_marks.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error(err);
      alert("No internal marks available ❌");
    }
  };

  const handleDownloadAllInternalMarksPDF = async () => {
    let fakeInterval = null;
    try {
      setIsDownloading(true);
      setDownloadProgress(0);

      const payload = {
        courses: courses.map((c) => ({
          exam_course_id: c.exam_course_id,
          course_code: c.course_code,
          course_name: c.course_name,
          course_type: c.course_type,
          internal_maximum: c.internal_maximum,
          program_name: c.program_name,
          branch_name: c.branch_name,
          admittedbatch: c.admittedbatch,
          student_rollnos: c.student_rollnos || [],
          year_number: c.year_number,
          semester_number: c.semester_number,
        })),
      };
      let fakeProgress = 0;
      fakeInterval = setInterval(() => {
        fakeProgress = Math.min(fakeProgress + 5, 90);
        setDownloadProgress(fakeProgress);
      }, 500);
      const res = await axios.post(
        `${API_BASE_URL}/api/internal-marks/student-list-pdf-all-marks/${clientId}/${collegeId}`,
        payload,
        {
          responseType: "blob",
          onDownloadProgress: (progressEvent) => {
            if (progressEvent.total) {
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setDownloadProgress(percent);
            }
          },
        }
      );

      const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      window.open(url);

      setDownloadProgress(100);
    } catch (err) {
      console.error(err);
      alert("No internal marks available ❌");
    } finally {
      setIsDownloading(false);
      clearInterval(fakeInterval);
      setDownloadProgress(100);
    }
  };

  // ADD BELOW handleDownloadStudentList()
  const handleDownloadAllStudentListCSV = (component) => {
    courses.forEach((course) => {
      if (!course.student_rollnos || course.student_rollnos.length === 0) return;

      let csv = "sno,course_code,course_name,component_id,component_name,student_rollno,marks\n";

      course.student_rollnos.forEach((rollno, index) => {
        const sno = index + 1;
        csv += `${sno},${course.course_code},${course.course_name},${component.component_id},${component.component_name},${rollno},\n`;
      });

      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      // ✅ separate file per course
      link.download = `${course.course_code}_${course.course_name}_${component.component_name}_students.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    });
  };

  // ADD BELOW handleDownloadStudentListPDF()
  const handleDownloadAllStudentListPDF = async (component) => {
    const payload = {
      component,
      courses: courses.map((c) => ({
        exam_course_id: c.exam_course_id,
        course_code: c.course_code,
        course_name: c.course_name,
        program_name: c.program_name,
        branch_name: c.branch_name,
        admittedbatch: c.admittedbatch,
        student_rollnos: c.student_rollnos || [],
        year_number: c.year_number,
        semester_number: c.semester_number,
      })),
    };

    const res = await axios.post(
      `${API_BASE_URL}/api/internal-marks/student-list-pdf-all/${clientId}/${collegeId}`,
      payload,
      { responseType: "blob" }
    );

    const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    window.open(url);
  };

  return (
    <>
      {/* 🔹 EXPORT BUTTONS */}
      <Stack
        direction="row"
        spacing={2}
        sx={{
          mb: 2,
          p: 2,
          backgroundColor: "#f8f9fa",
          borderRadius: 2,
          boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
          border: "1px solid #e0e0e0",
        }}
      >
        <Button
          variant="contained"
          onClick={handleCSV}
          sx={{
            color: "green",
            backgroundColor: "#f8f9fa",
            "&:hover": { backgroundColor: "rgba(152, 152, 232, 0.1)" },
          }}
        >
          Courses CSV
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={handlePDF}
          sx={{
            color: "green",
            backgroundColor: "#f8f9fa",
            "&:hover": { backgroundColor: "rgba(148, 148, 225, 0.1)" },
          }}
        >
          Courses PDF
        </Button>

        <Button
          variant="outlined"
          onClick={handlePrint}
          sx={{
            color: "green",
            backgroundColor: "#f8f9fa",
            "&:hover": { backgroundColor: "rgba(128, 128, 220, 0.1)" },
          }}
        >
          Courses Print
        </Button>
        <Button
          variant="outlined"
          onClick={() => setComponentDialogAllOpen(true)}
          sx={{
            color: "green",
            backgroundColor: "#f8f9fa",
            "&:hover": { backgroundColor: "rgba(128, 128, 220, 0.1)" },
          }}
        >
          Roll List(CSV/PDF)
        </Button>
        <Button
          variant="outlined"
          onClick={handleDownloadAllInternalMarks}
          sx={{
            color: "green",
            backgroundColor: "#f8f9fa",
            "&:hover": { backgroundColor: "rgba(128, 128, 220, 0.1)" },
          }}
        >
          Internal marks CSV
        </Button>
        <Button
          variant="outlined"
          onClick={handleDownloadAllInternalMarksPDF}
          sx={{
            color: "green",
            backgroundColor: "#f8f9fa",
            "&:hover": { backgroundColor: "rgba(128, 128, 220, 0.1)" },
          }}
        >
          All Internal marks PDF
        </Button>
      </Stack>
      {isDownloading && (
        <div style={{ marginTop: "10px" }}>
          <div
            style={{
              width: "100%",
              height: "10px",
              background: "#e0e0e0",
              borderRadius: "5px",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                width: `${downloadProgress}%`,
                height: "100%",
                background: "#4caf50",
                transition: "width 0.3s ease",
              }}
            />
          </div>
          <div style={{ textAlign: "center", marginTop: "5px" }}>
            Downloading PDF… {downloadProgress}%
          </div>
        </div>
      )}

      {/* 🔹 DATAGRID */}
      <div style={{ height: 500, width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          getRowId={(row) => row.exam_course_id}
          initialState={{
            pagination: { paginationModel: { pageSize: 15, page: 0 } },
          }}
          pageSizeOptions={[10, 20, 50]}
        />
      </div>
      <ComponentSelectDialog
        open={componentDialogOpen}
        collegeId={collegeId}
        clientId={clientId}
        courseRow={selectedCourseRow}
        onClose={() => setComponentDialogOpen(false)}
        onConfirm={(courseRow, component) => {
          handleDownloadStudentList(courseRow, component);
          setComponentDialogOpen(false);
        }}
        onConfirmPDF={(courseRow, component) => {
          handleDownloadStudentListPDF(courseRow, component);
          setComponentDialogOpen(false);
        }}
        onOpenMarksEntry={(courseRow, component) => {
          setSelectedCourseRow(courseRow); // ✅ SET COURSE
          setSelectedComponent(component); // ✅ SET COMPONENT
          setMarksDialogOpen(true); // ✅ OPEN DIALOG
          setComponentDialogOpen(true);
        }}
      />
      <ComponentSelectDialog
        open={componentDialogAllOpen}
        collegeId={collegeId}
        clientId={clientId}
        onClose={() => setComponentDialogAllOpen(false)}
        onConfirm={(component) => {
          handleDownloadAllStudentListCSV(component);
          setComponentDialogAllOpen(false);
        }}
        onConfirmPDF={(component) => {
          handleDownloadAllStudentListPDF(component);
          setComponentDialogAllOpen(false);
        }}
      />
      <ComponentSelectMarksDialog
        open={componentMarksDialogOpen}
        collegeId={collegeId}
        clientId={clientId}
        courseRow={selectedCourseMarksRow}
        onClose={() => setComponentMarksDialogOpen(false)}
        onConfirmMarks={(courseRow, component) => {
          handleDownloadMarksList(courseRow, component);
          setComponentMarksDialogOpen(false);
        }}
      />
      <MarksEntryDialog
        key={`${selectedCourseRow?.exam_course_id}-${selectedComponent?.component_id}`}
        open={marksDialogOpen}
        onClose={closeMarksDialog}
        courseRow={selectedCourseRow}
        component={selectedComponent}
        clientId={clientId}
        collegeId={collegeId}
      />
    </>
  );
}
CourseAllotmentGrid.propTypes = {
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      exam_course_id: PropTypes.string.isRequired,
      course_code: PropTypes.string.isRequired,
      course_name: PropTypes.string.isRequired,
      course_type: PropTypes.string.isRequired,
      course_category: PropTypes.string.isRequired,
      allotted_count: PropTypes.number.isRequired,
      program_name: PropTypes.string.isRequired,
      branch_name: PropTypes.string.isRequired,
      admittedbatch: PropTypes.string.isRequired,
      year_number: PropTypes.number.isRequired,
      semester_number: PropTypes.number.isRequired,
    })
  ).isRequired,
  program: PropTypes.string,
  branch: PropTypes.string,
  admittedbatch: PropTypes.string,
};
